export const MIN_COMM_SELECTION = 2;
